import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './PaymentSuccess.css'; // 같은 스타일 사용
import { useTranslation } from '../redux/TranslationHelper';

const PaymentFail = ({ componentProps, style }) => {
  const { t } = useTranslation();
  
  // 컴포넌트 속성 기본값 설정
  const {
    className = "payment-fail-wrapper",
    title = t("결제에 실패했습니다"),
    errorDefaultMessage = t("결제 처리 중 오류가 발생했습니다."),
    cartButtonText = t("장바구니로 돌아가기"),
    homeButtonText = t("홈으로 돌아가기"),
    showErrorDetails = true,
    redirectToHome = "/",
    redirectToCart = "/cart"
  } = componentProps || {};

  // 기본 스타일 + props로 받은 스타일 병합
  const mergedStyle = {
    width: '100%',
    ...style
  };
  
  const location = useLocation();
  const navigate = useNavigate();
  
  // URL에서 에러 메시지 추출
  const searchParams = new URLSearchParams(location.search);
  const errorCode = searchParams.get('code');
  const errorMessage = searchParams.get('message') || errorDefaultMessage;
  const orderId = searchParams.get('orderId');

  const handleGoToCart = () => {
    navigate(redirectToCart);
  };

  const handleGoToHome = () => {
    navigate(redirectToHome);
  };

  return (
    <div className={className} style={mergedStyle}>
      <div className="payment-result-container">
        <div className="payment-result-card error">
          <div className="error-icon">❌</div>
          <h2>{title}</h2>
          
          {showErrorDetails && (
            <div className="payment-info">
              {orderId && (
                <div className="info-row">
                  <span className="label">{t("주문번호")}:</span>
                  <span className="value">{orderId}</span>
                </div>
              )}
              {errorCode && (
                <div className="info-row">
                  <span className="label">{t("오류 코드")}:</span>
                  <span className="value">{errorCode}</span>
                </div>
              )}
              <div className="info-row">
                <span className="label">{t("오류 메시지")}:</span>
                <span className="value">{errorMessage}</span>
              </div>
            </div>
          )}
          
          <div className="payment-action-buttons">
            <button onClick={handleGoToCart} className="view-cart-button">
              {cartButtonText}
            </button>
            <button onClick={handleGoToHome} className="go-home-button">
              {homeButtonText}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentFail; 